import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TGetNewMessageCountResponsePayload,
	TMessagesResponsePayload,
	TOrganizationsResponsePayload,
	TOrganizationsRow,
	TUserInfoResponsePayload,
	TUserStore,
	TMarkAsReadMessageRequest,
	TDeleteMessageRequest,
	THubspotVisitorTokenResponsePayload,
} from './types';
// ==========================================:
export const initialState: TUserStore = {
	organizations: null,
	organizationsLoader: false,
	userInfo: null,
	userInfoLoader: false,
	xMerchantId: null,
	setOrganization: null,
	newMessageCount: 0,
	newMessageCountLoader: false,
	messages: null,
	messagesLoader: false,
	markAsReadMessageLoader: false,
	deleteMessageLoader: false,
	hubsportVisitorToken: null,
	hubsportVisitorTokenLoader: false,
};

// ==========================================:
const user = createSlice({
	name: '@@user',
	initialState,
	reducers: {
		getOrganizationsRequest: (state: TUserStore) => {
			const organizationsRequestState = state;
			organizationsRequestState.organizationsLoader = true;
		},
		getOrganizationsSuccess: (
			state: TUserStore,
			action: PayloadAction<TOrganizationsResponsePayload>,
		) => {
			const { payload } = action;
			const organizationsSuccessState = state;
			organizationsSuccessState.organizations = payload;
			organizationsSuccessState.organizationsLoader = false;
		},
		setOrganization: (state: TUserStore, action: PayloadAction<TOrganizationsRow>) => {
			const { payload } = action;
			const setOrganizationState = state;
			setOrganizationState.setOrganization = payload;
		},

		getUserInfoRequest: (state: TUserStore) => {
			const userInfoRequestState = state;
			userInfoRequestState.userInfoLoader = true;
		},
		getUserInfoSuccess: (state: TUserStore, action: PayloadAction<TUserInfoResponsePayload>) => {
			const { payload } = action;
			const userInfoSuccessState = state;
			userInfoSuccessState.userInfo = payload;
			userInfoSuccessState.userInfoLoader = false;
		},
		setXMerchantId: (state: TUserStore, action: PayloadAction<string>) => {
			const { payload } = action;
			const setXMerchantIdState = state;
			setXMerchantIdState.xMerchantId = payload;
		},
		getNewMessageCountRequest: (state: TUserStore) => {
			const newMessageCountRequestState = state;
			newMessageCountRequestState.newMessageCountLoader = true;
		},
		getNewMessageCountSuccess: (
			state: TUserStore,
			action: PayloadAction<TGetNewMessageCountResponsePayload>,
		) => {
			const { payload } = action;
			const newMessageCountSuccessState = state;
			newMessageCountSuccessState.newMessageCount = payload;
			newMessageCountSuccessState.newMessageCountLoader = false;
		},
		getMessagesRequest: (state: TUserStore) => {
			const getMessagesState = state;
			getMessagesState.messagesLoader = true;
		},
		getMessagesSuccess: (state: TUserStore, action: PayloadAction<TMessagesResponsePayload>) => {
			const { payload } = action;
			const getMessagesSuccessState = state;
			getMessagesSuccessState.messages = payload;
			getMessagesSuccessState.messagesLoader = false;
		},
		markAsReadMessageRequest: (
			state: TUserStore,
			action: PayloadAction<TMarkAsReadMessageRequest>,
		) => {
			const markAsReadMessageState = state;
			markAsReadMessageState.markAsReadMessageLoader = true;
		},
		markAsReadMessageSuccess: (state: TUserStore) => {
			const markAsReadMessageSuccessState = state;
			markAsReadMessageSuccessState.markAsReadMessageLoader = false;
		},
		deleteMessageRequest: (state: TUserStore, action: PayloadAction<TDeleteMessageRequest>) => {
			const deleteMessageState = state;
			deleteMessageState.deleteMessageLoader = true;
		},
		deleteMessageSuccess: (state: TUserStore) => {
			const deleteMessageSuccessState = state;
			deleteMessageSuccessState.deleteMessageLoader = false;
		},
		getHubspotVisitorTokenRequest: (state: TUserStore) => {
			const getHubspotVisitorTokenState = state;
			getHubspotVisitorTokenState.hubsportVisitorTokenLoader = true;
		},
		getHubspotVisitorTokenSuccess: (
			state: TUserStore,
			action: PayloadAction<THubspotVisitorTokenResponsePayload>,
		) => {
			const { payload } = action;
			const getHubspotVisitorTokenSuccessState = state;
			getHubspotVisitorTokenSuccessState.hubsportVisitorToken = payload;
			getHubspotVisitorTokenSuccessState.hubsportVisitorTokenLoader = false;
		},

		userInitState: () => initialState,
	},
});

export default user.reducer;
export const {
	getOrganizationsRequest,
	getOrganizationsSuccess,
	setOrganization,
	getUserInfoRequest,
	getUserInfoSuccess,
	setXMerchantId,
	getNewMessageCountRequest,
	getNewMessageCountSuccess,
	getMessagesRequest,
	getMessagesSuccess,
	markAsReadMessageRequest,
	markAsReadMessageSuccess,
	deleteMessageRequest,
	deleteMessageSuccess,
	getHubspotVisitorTokenRequest,
	getHubspotVisitorTokenSuccess,
	userInitState,
} = user.actions;
